<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp" :sticky="sticky">
    <ProjectDocumentsTableItem
      v-for="(item, key) in items"
      :key="key"
      :itemKey="key"
      :item="item"
      :page="page"
      :limit="limit"
      :edit="edit"
      :documentTypeList="documentTypeList"
      @itemData="onItemData"
      :editShowPage="editShowPage"
    />
    <ProjectDocumentsTableItem
      v-for="(item, key) in itemsUpload"
      :key="'download' + key"
      :item="item"
      :upload="true"
    />
  </BaseTableView>
</template>

<script>
import ProjectDocumentsTableItem from 'components/project/schemesAndDocuments/documents/ProjectDocumentsTableItem'
import BaseTableView from "components/base/tableview/BaseTableView";
export default {
  name: 'SalesProjectCreateDocumentTable',
  props: [
    'items',
    'itemsUpload',
    'page',
    'limit',
    'edit',
    'documentTypeList',
    'workAreaList',
    'editShowPage',
    'sticky'
  ],
  components: {BaseTableView, ProjectDocumentsTableItem },
  data() {
    return {
      documentsData: [],
      tableMin: false,
    }
  },
  computed: {
    t() {
      return this.localStorage.translations.pages['sales_project']['schemes_documents-tables']
    },
    tableHead() {
      return [
        {text: this.t['nazvanie']},
        {text: this.t['tip-dokumenta']},
        {text: this.t['data']},
        {text: '', active: true},
      ]
    },
  },
  methods: {
    onItemData(value) {
      const itemKey = value.key
      if (this.documentsData[itemKey]) {
        this.documentsData[itemKey] = value.data
      } else {
        this.documentsData.push(value.data)
      }
      if (this.documentsData.length == this.items.length) {
        value.data = this.documentsData
        this.$emit('documentsTableData', value)
      }
    },
    onMin(value) {
      this.tableMin = value
    },
  },
  watch: {
    edit() {
      if (!this.edit) {
        this.documentsData = []
      }
    },
  },
}
</script>
